* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 2.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

gz-data-table {
  --column-max-width: unset;
}

gz-policy-panel-exchange-antispam-rules-grid, gz-policy-panel-exchange-antispam-settings-table {
  margin-top: -25px;
}
